import { filter, MonoTypeOperatorFunction } from "rxjs";


export function notEmptyFilter<T>(): MonoTypeOperatorFunction<T> {
    return filter((value: T) => value !== undefined && value !== null)
}
